export function parseWithMask(raw: string = '', decimalPlaces = 2) {
  const value = parseFloat(raw);

  if (isNaN(value)) return 0;

  const [whole, decimals] = raw.split('.');

  if (decimalPlaces <= 0) return parseInt(whole);

  if (decimals !== undefined && decimals.length === decimalPlaces) return parseFloat(`${whole}.${decimals}`);

  // get the input value, and remove non-digit characters
  const digitsOnly = raw.replace(/\D/g, '');

  // left pad with zeros if needed
  const padded = `${'0'.repeat(Math.max(0, decimalPlaces - digitsOnly.length))}${digitsOnly}`;

  // preserve negative
  return (value < 0 ? -1 : 1) * parseFloat(`${padded.substr(0, padded.length - decimalPlaces)}.${padded.substr(padded.length - decimalPlaces)}`);
}
